import Service from '../Service';
import { ResponseErrorBody, ResponseSuccessBodyDevices } from '../../types';
import Request from '../Request';
import { addFingerprintToRequest } from './utils';

export default async function() {
  const request = await addFingerprintToRequest(
    new Request('/api/auth/devices').setMethod('GET')
  );
  const service = new Service<ResponseSuccessBodyDevices, ResponseErrorBody>(
    request
  );
  return await service.send();
}

export async function newLocation(deviceId: string, activationToken: string) {
  const request = await addFingerprintToRequest(
    new Request(
      `/api/auth/devices/${deviceId}/newlocation?token=${activationToken}`
    ).setMethod('GET')
  );
  const service = new Service<any, ResponseErrorBody>(request);
  return await service.send();
}

export async function activate(deviceId: string, activationToken: string) {
  const request = await addFingerprintToRequest(
    new Request(
      `/api/auth/devices/${deviceId}/activate?token=${activationToken}`
    ).setMethod('GET')
  );
  const service = new Service<any, ResponseErrorBody>(request);
  return await service.send();
}
